import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import TablaServidor from '../../components/tabla/TablaServidor';
import ModalClickable from '../../layouts/modals/ModalClickable';
import { AuthContext } from '../../context/authContext';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import gruposService from '../../services/http/gruposService';
import logger from '../../services/logger';
import { COLUMNAS_GRUPOS, TABLA_GRUPOS } from '../../components/grupos/columnasGrupos';

const Grupos = () => {
  useTituloCabecera('Grupos', 'Listado de grupos de las dos sedes');
  const navigate = useNavigate();
  const { userOU } = useContext(AuthContext);
  const [clonado, setClonado] = useState(false);
  const [refresco, setRefresco] = useState(0);

  const clonar = async (fila) => {
    try {
      await gruposService.clonarGrupo({ headquarter: fila.empresaId, data: fila });
      setClonado(true);
      setRefresco((n) => n + 1);
    } catch (error) {
      logger.error('Error al clonar el grupo:', error);
    }
  };

  const acciones = (fila) =>
    userOU?.centro === 'SUPERADMIN' ? (
      <Button
        color="primary"
        size="sm"
        onClick={(e) => {
          e.stopPropagation();
          clonar(fila);
        }}
      >
        Clonar
      </Button>
    ) : null;

  return (
    <>
      {clonado && <ModalClickable header="Grupo clonado correctamente." function={setClonado} />}
      <TablaServidor
        tablaKey={TABLA_GRUPOS}
        columnas={COLUMNAS_GRUPOS}
        ruta="listado-grupos"
        archivo="grupos"
        nombreEntidad="grupos"
        placeholder="Buscar por nombre o código de grupo…"
        refresco={refresco}
        claveFila={(f) => `${f.empresaId}-${f.codigo}`}
        onFilaClick={(f) => navigate(`/grupos/detalles/${f.empresaId}/${f.codigo}`)}
        renderAcciones={acciones}
        tituloTarjeta={(f) => f.grupo || `#${f.codigo}`}
      />
    </>
  );
};

export default Grupos;
